export const getUuid = (): string => crypto.randomUUID();
